export enum TicketStatus {
    all = 0,
    open = 1,
    pending = 2,
    completed = 3,

    notCompleted = 4,
}
